import {
  decodeGoogleRoutesEncodedPolyline,
  decodeIntegerDeltaSeries,
} from '@gpx-spa/geo-adapters';

const BATTERY_MISSING = -1;

export type ShipmentsTrackBatchRowInput = {
  shipment_id: number;
  device_id: number;
  data: {
    encoded_polyline: string;
    timestamp: string;
    battery: string;
    fix_type?: string;
    accuracy?: string;
    count?: number;
  };
};

export type DecodedShipmentTrackPoint = {
  location: [number, number];
  timestampSec: number;
  battery: number | null;
  /** null when the API row has no fix_type series (legacy response). */
  fixTypeCode: number | null;
  /** null when the API row has no accuracy series (legacy response). */
  accuracyMeters: number | null;
};

export type DecodedShipmentTrack = {
  /** GeoJSON LineString coordinates [lng, lat][] */
  coordinates: [number, number][];
  /** Points aligned with vertices (for popups / circles) */
  points: DecodedShipmentTrackPoint[];
};

export function decodeShipmentTrackRow(
  row: ShipmentsTrackBatchRowInput | undefined | null,
): DecodedShipmentTrack | null {
  if (!row?.data?.encoded_polyline) {
    return null;
  }
  const {
    encoded_polyline,
    timestamp: tsEnc,
    battery: batEnc,
    fix_type: fixEnc,
    accuracy: accEnc,
  } = row.data;
  const lngLats = decodeGoogleRoutesEncodedPolyline(encoded_polyline);
  if (!lngLats.length) {
    return null;
  }
  const ts = tsEnc ? decodeIntegerDeltaSeries(tsEnc) : [];
  const bat = batEnc ? decodeIntegerDeltaSeries(batEnc) : [];
  const hasFixType = typeof fixEnc === 'string';
  const hasAccuracy = typeof accEnc === 'string';
  const fix = hasFixType && fixEnc ? decodeIntegerDeltaSeries(fixEnc) : [];
  const acc = hasAccuracy && accEnc ? decodeIntegerDeltaSeries(accEnc) : [];
  const coordinates = lngLats.map((c) => [c[0], c[1]] as [number, number]);
  const points = lngLats.map((coord, i) => ({
    location: [coord[0], coord[1]] as [number, number],
    timestampSec: ts[i] ?? 0,
    battery:
      bat[i] === undefined || bat[i] === BATTERY_MISSING ? null : bat[i]!,
    fixTypeCode: hasFixType ? (fix[i] ?? 0) : null,
    accuracyMeters: hasAccuracy ? (acc[i] ?? 0) : null,
  }));
  return { coordinates, points };
}
